module.exports = __webpack_public_path__ + "static/media/picture_audience.5227ec46.png";